import {cva} from 'class-variance-authority';

export const toastVariants = cva(
  'group pointer-events-auto relative flex min-h-13 w-full items-center gap-4 overflow-hidden rounded-[10px] py-1 pr-0 pl-4 shadow-default transition-all data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-(--radix-toast-swipe-end-x) data-[swipe=move]:translate-x-(--radix-toast-swipe-move-x) data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full',
  {
    variants: {
      variant: {
        default:
          'toast-general bg-neutral-900 text-neutral-200 [&_[data-slot=toast-icon]]:bg-neutral-200 [&_[data-slot=toast-icon]>svg]:text-neutral-900',
        general:
          'toast-general bg-neutral-900 text-neutral-200 [&_[data-slot=toast-icon]]:bg-neutral-200 [&_[data-slot=toast-icon]>svg]:text-neutral-900',
        destructive:
          'toast-error destructive bg-danger-100 text-danger-800 [&_[data-slot=toast-icon]]:bg-danger-800 [&_[data-slot=toast-icon]>svg]:text-white',
        error:
          'toast-error bg-danger-100 text-danger-800 [&_[data-slot=toast-icon]]:bg-danger-800 [&_[data-slot=toast-icon]>svg]:text-white',
        success:
          'toast-success bg-accent-100 text-primary-dark [&_[data-slot=toast-icon]]:bg-accent-700 [&_[data-slot=toast-icon]>svg]:text-white',
        warning:
          'toast-warning bg-warning-200 text-orange-800 [&_[data-slot=toast-icon]]:bg-orange-700 [&_[data-slot=toast-icon]>svg]:text-white',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);
